import { render } from "./detail-monitoring-pembelajaran-peserta.vue?vue&type=template&id=c6f54796"
import script from "./detail-monitoring-pembelajaran-peserta.vue?vue&type=script&lang=js"
export * from "./detail-monitoring-pembelajaran-peserta.vue?vue&type=script&lang=js"

import "./detail-monitoring-pembelajaran-peserta.vue?vue&type=style&index=0&id=c6f54796&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__